import React from 'react';
import {Col, Row} from 'antd';
import InputField from '../../../../input-field';
import DividerBlock from "../../../../divider-block";
import i18n from "../../../../../i18n";

export default function GuarantorFields({ stepFields, setFields, getFieldErrors, edit = false }) {
	let dividerStyle = {
		margin: "15px 0px 45px 0px",
		display: "block",
		clear: "both",
		width: "100%",
		minWidth: "100%",
		height: "1px",
	};
    return (
        <>
           <Row gutter={[16,24]}>
            <Col lg={8} sm={24}>
              <InputField
                name="guarantorFirstName"
                title={i18n.t('constants.formFields.FirstName')}
                label="Vardas"
                required={true}
                value={stepFields.guarantorFirstName}
                setValue={(value) => {setFields({...stepFields, guarantorFirstName: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
              <Col lg={8} sm={24}>
                <InputField
                  name="guarantorSecondName"
                  title={i18n.t('constants.formFields.SecondName')}
                  label="Pavardė"
                  required={true}
                  value={stepFields.guarantorSecondName}
                  setValue={(value) => {setFields({...stepFields, guarantorSecondName: value});}}
                  getFieldErrors={getFieldErrors}
                />
            </Col>
              <Col lg={8} sm={24}>
                <InputField
                  name="guarantorPatronymic"
                  title={i18n.t('constants.formFields.Patronymic')}
                  label="Antras vardas"
                  required={true}
                  value={stepFields.guarantorPatronymic}
                  setValue={(value) => {setFields({...stepFields, guarantorPatronymic: value});}}
                  getFieldErrors={getFieldErrors}
                />
              </Col>
          </Row>
			<span className="divider-label">Paso duomenys</span>
			<DividerBlock style={dividerStyle} />
           <Row gutter={[16,24]}>
            <Col lg={12} sm={24}>
              <InputField
                name="guarantorPassportSerial"
                title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPassportSerial.title')}
                label="Serija"
                required={true}
                value={stepFields.guarantorPassportSerial}
                setValue={(value) => {setFields({...stepFields, guarantorPassportSerial: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} sm={24}>
              <InputField
                name="guarantorPassportNumber"
                title={i18n.t('modals.modalCreateNewLegalEntity.fields.guarantorPassportNumber.title')}
                label="Paso ID"
                required={true}
                value={stepFields.guarantorPassportNumber}
                setValue={(value) => {setFields({...stepFields, guarantorPassportNumber: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
			<span className="divider-label">Kontaktiniai duomenys</span>
			<DividerBlock style={dividerStyle} />
           <Row gutter={[16,24]}>
            <Col lg={12} sm={24}>
              <InputField
                name="guarantorCountry"
                title={i18n.t('modals.modalCreateNewLegalEntity.fields.country.title')}
                label="Registracijos šalis"
                required={true}
                value={stepFields.guarantorCountry}
                setValue={(value) => {setFields({...stepFields, guarantorCountry: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} sm={24}>
              <InputField
                name="guarantorAddressFact"
                title={i18n.t('constants.formFields.RegAddress')}
                label="Adresas"
                required={true}
                value={stepFields.guarantorAddressFact}
                setValue={(value) => {setFields({...stepFields, guarantorAddressFact: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
           <Row gutter={[16,24]}>
            <Col lg={12} sm={24}>
              <InputField
                name="guarantorPhone"
                title={i18n.t('constants.legalEntityDataAliases.Phone')}
                label="Telefono numeris"
                required={true}
                value={stepFields.guarantorPhone}
                setValue={(value) => {setFields({...stepFields, guarantorPhone: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} sm={24}>
              <InputField
                name="guarantorEmail"
                label="Email"
                required={true}
                value={stepFields.guarantorEmail}
                setValue={(value) => {setFields({...stepFields, guarantorEmail: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
        </>
    );
}
